import type { UserInfo } from "@/types";

const MD_LOGIN_ID = "md-login";

const isTruthyAttr = (raw: string | null | undefined) => {
  const v = (raw ?? "").trim().toLowerCase();
  return v === "true" || v === "1" || v === "yes";
};

/**
 * Vite dev only: when `#md-login` has `data-dev-mock-logged-in="true"`, bootstrap
 * skips `fetchAlreadyLoggedIn` and uses a local user so the logged-in UI can be
 * previewed without OAuth. Stripped / inert in production builds (`import.meta.env.DEV` is false).
 */
export const isDevMockLoggedInEnabled = (): boolean => {
  if (!import.meta.env.DEV) return false;
  const el = document.getElementById(MD_LOGIN_ID);
  if (!el) return false;
  return isTruthyAttr(el.getAttribute("data-dev-mock-logged-in"));
};

/**
 * Vite dev only: `data-dev-open-chatbot="true"` on `#md-login` forces `data-chatbot`
 * behaviour for local preview, seeds a dummy chatbot ticket payload, and opens the
 * chatbot modal after bootstrap. Inert in production IIFE.
 */
export const isDevOpenChatbotPreviewEnabled = (): boolean => {
  if (!import.meta.env.DEV) return false;
  const el = document.getElementById(MD_LOGIN_ID);
  if (!el) return false;
  return isTruthyAttr(el.getAttribute("data-dev-open-chatbot"));
};

/** Minimal payload so the modal is not stuck in “missing ticket” (Continue still hits the API). */
export const buildDevChatbotAuthPayload = (): Record<string, unknown> => ({
  FsVersion: "3",
  expires: 1800,
  ticket: "dev-local-chatbot-preview",
});

export const buildDevMockLoggedInUser = (): UserInfo => ({
  firstName: "User",
  lastName: "User",
  avatarUrl: "https://via.placeholder.com/150",
  installationId: "",
  guid: "00000000-0000-0000-0000-000000000001",
  username: "user.user",
});
